import {
  createRouter,
  // createWebHashHistory,
  RouteRecordRaw,
  createWebHistory,
} from "vue-router";
import { createStore } from "@/vuex/store";
import { ElMessage } from "element-plus";
import { getCurrentFullDomain, judgementShwo, rightJudgment } from "@/utils/utils";
import authMenu from "@/common/menuList.json";
import { abilityEntryPath } from "@/views/console/Ability/abilityAccess";

// import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "portal",
    // redirect: "/portal",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/portal/pLayout_new.vue"),
    children: [
      {
        path: "/portal",
        name: "portalPage",
        component: () => import("@/views/portal/components/portalPage.vue"),
      },
    ],
  },
  {
    path: "/portalNew",
    name: "portalNew",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/portal/pLayout_new.vue"),
    children: [
      {
        path: "/portalNew",
        name: "portalNews",
        component: () => import("@/views/portal/pLayout_new.vue"),
      },
    ],
  },
  {
    path: "/home",
    name: "home",
    redirect: "/home",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/HomeView/index.vue"),
    children: [
      {
        path: "/home",
        name: "HomeAll",
        component: () => import("@/views/HomeAll.vue"),
      },
      {
        path: "/square",
        name: "square",
        component: () => import("@/views/Square.vue"),
      },
      {
        // Public app page; prompt / knowledge-base / workflow apps open in the
        // unified conversation page, other kinds keep the legacy chat view.
        path: "/app/:code",
        name: "app",
        component: () => import("@/views/HomeView/AppEntry.vue"),
      },
      {
        path: "/paint",
        name: "paintPic",
        component: () => import("@/views/PaintPic.vue"),
      },
      {
        path: "/plugin",
        name: "plugin",
        component: () => import("@/views/HomePlugin.vue"),
      },
      {
        // /models is served by the portal; in-app navigation goes to the console.
        path: "/models",
        redirect: "/console/models",
      },
      {
        path: "/templates",
        name: "template",
        component: () => import("@/views/console/TemplateCenter/index.vue"),
      },
      {
        path: "/template/:code",
        name: "templateCode",
        component: () =>
          import("@/views/console/TemplateCenter/TemplateChat.vue"),
      },
      {
        // 创作：实际不渲染页面，导航守卫会拦截并跳转到 studioDomainName 外链
        path: "/creation",
        name: "creation",
        component: () => import("@/views/console/TemplateCenter/index.vue"),
        meta: { externalStudioDomain: true },
      },
    ],
  },
  {
    path: "/console",
    name: "console",
    redirect: "/console/factory",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/console/index.vue"),
    children: [
      {
        path: "/console/factory",
        name: "myApp",
        component: () => import("@/views/console/MyApp/index.vue"),
        meta: {
          showPath: "/console/factory",
          tabName: "/ 创造 / 智能体",
          titleName: "智能体",
        },
      },
      {
        path: "/console/interface",
        name: "openInterface",
        component: () =>
          import("@/views/console/AppInterface/OpenInterface.vue"),
        meta: {
          showPath: "/console/interface",
          tabName: "/ 接入 / 渠道接入",
          titleName: "渠道接入",
        },
      },
      // {
      //   path: "/console/dataAnalysis",
      //   name: "dataAnalysis",
      //   component: () => import("@/views/console/DataAnalysis.vue"),
      //   meta: {
      //     showPath: '/console/dataAnalysis',
      //     tabName: '/管理/数据看板'
      //   }
      // },

      {
        path: "/console/createApp",
        name: "createApp",
        component: () => import("@/views/console/CreateApp.vue"),
        meta: {
          showPath: "/console/factory",
          tabName: "/ 创造 / 智能体 / 创建应用",
          titleName: "智能体",
        },
      },
      {
        path: "/console/agent",
        name: "EmbeddingApp",
        component: () => import("@/views/console/EmbeddingApp/index.vue"),
        meta: {
          showPath: "/console/factory",
          tabName: "/ 创造 / 智能体 / 配置",
          titleName: "智能体",
        },
      },
      {
        path: "/console/superagent",
        name: "superAgent",
        component: () => import("@/views/console/MyApp/SuperagentDetail.vue"),
        meta: {
          showPath: "/console/factory",
          tabName: "/ 创造 / 智能体 / 超级AI助理",
          titleName: "智能体",
        },
      },
      {
        // Old address of the conversation page; keep bookmarks / shared links working.
        path: "/console/superagent/chat",
        redirect: (to) => ({ path: "/console/agent/chat", query: to.query }),
      },
      {
        // IM-style conversations with agents (single / group), apps and workflows
        path: "/console/agent/chat",
        name: "agentChat",
        component: () => import("@/views/console/superAgent/chat/index.vue"),
        meta: {
          showPath: "/console/factory",
          tabName: "/ 创造 / 智能体 / 多智能体会话",
          titleName: "智能体",
        },
      },
      {
        path: "/console/superagent/download",
        name: "clientDownload",
        component: () =>
          import("@/views/console/superAgent/ClientDownload.vue"),
        meta: {
          showPath: "/console/factory",
          tabName: "/ 创造 / 智能体 / 下载",
          titleName: "下载客户端",
        },
      },
      {
        // Deep link: open the download page with a version's release notes expanded
        path: "/console/superagent/download/:version/detail",
        name: "clientDownloadDetail",
        component: () =>
          import("@/views/console/superAgent/ClientDownload.vue"),
        meta: {
          showPath: "/console/factory",
          tabName: "/ 创造 / 智能体 / 下载",
          titleName: "下载客户端",
        },
      },
      {
        path: "/console/multiAgent",
        name: "multiAgent",
        component: () => import("@/views/console/multiAgent/index.vue"),
        meta: {
          showPath: "/console/factory",
          tabName: "/ 创造 / 智能体 / 多智能体配置",
          titleName: "多智能体",
        },
      },
      {
        path: "/console/account",
        name: "myCenter",
        component: () => import("@/views/console/myCenter/MyCenter.vue"),
        meta: {
          showPath: "/console/account",
          tabName: "/ 管理 / 我的账户",
          titleName: "我的账户",
        },
      },

      {
        path: "/console/chatManage",
        name: "chatManage",
        component: () => import("@/views/console/ChatManage.vue"),
        meta: {
          showPath: "/console/chatManage",
          tabName: "/ 接入 / 对话管理",
          titleName: "对话管理",
        },
      },
      // {
      //   path: "/console/ChatIphone",
      //   name: "chatManage",
      //   component: () => import("@/views/console/ChatIphone.vue"),
      // },
      {
        path: "/console/clients",
        name: "clients",
        component: () => import("@/views/console/Clients/ClientsList.vue"),
        meta: {
          showPath: "/console/clients",
          tabName: "/ 接入 / 客户端",
          titleName: "客户端",
        },
      },
      {
        path: "/console/dataAnalysis",
        name: "dataAnalysis",
        component: () => import("@/views/console/DataAnalysis/index.vue"),
        meta: {
          showPath: "/console/dataAnalysis",
          tabName: "/ 管理 / 数据看板",
          titleName: "数据看板",
        },
      },
      {
        path: "/console/dataAnalysis/followup",
        name: "dataAnalysisFollowup",
        component: () => import("@/views/console/DataAnalysis/Followup/index.vue"),
        meta: {
          showPath: "/console/dataAnalysis",
          tabName: "/ 管理 / 数据看板 / 随访运营",
          titleName: "随访运营看板",
        },
      },
      {
        path: "/console/clients/configClient",
        name: "configurationClient",
        component: () =>
          import("@/views/console/Clients/ConfigurationClient.vue"),
        meta: {
          showPath: "/console/clients",
          tabName: "/ 接入 / 客户端 / 客户端配置",
          titleName: "客户端",
        },
      },
      {
        path: "/console/clients/config",
        name: "configurationClientChat",
        component: () =>
          import("@/views/console/Clients/ConfigurationClientChat.vue"),
        meta: {
          showPath: "/console/clients",
          tabName: "/ 接入 / 客户端 / 客户端配置",
          titleName: "客户端",
        },
      },
      {
        path: "/console/clients/smartDevice",
        name: "smartDevice",
        component: () =>
          import("@/views/console/Clients/SmartDevice.vue"),
        meta: {
          showPath: "/console/clients",
          tabName: "/ 接入 / 客户端 / 智能设备",
          titleName: "客户端",
        },
      },
      {
        path: "/console/knowledge",
        name: "knowledge",
        component: () =>
          import("@/views/console/KnowledgeBase/KnowledgeBase.vue"),
        meta: {
          showPath: "/console/knowledge",
          tabName: "/ 创造 / 知识库",
          titleName: "知识库",
        },
      },
      {
        path: "/console/knowledge/knowledgeManage",
        name: "KnowledgeManage",

        component: () =>
          import("@/views/console/KnowledgeBase/KnowledgeManage.vue"),
        redirect: "/console/knowledge/files",
        children: [
          {
            path: "/console/knowledge/files",
            name: "files",

            component: () =>
              import("@/views/console/KnowledgeBase/BaseAll.vue"),
            meta: {
              showPath: "/console/knowledge",
              tabName: "/ 创造 / 知识库 / 文件管理",
              titleName: "知识库",
            },
          },
          {
            path: "/console/knowledge/baseFile",
            name: "baseFile",

            component: () =>
              import("@/views/console/KnowledgeBase/BaseFile.vue"),
            meta: {
              showPath: "/console/knowledge",
              tabName: "/ 创造 / 知识库",
              titleName: "知识库",
            },
          },
          {
            path: "/console/knowledge/importFile",
            name: "importFile",

            component: () =>
              import("@/views/console/KnowledgeBase/ImportFile.vue"),
            meta: {
              showPath: "/console/knowledge",
              tabName: "/ 创造 / 知识库 / 文件导入",
              titleName: "知识库",
            },
          },
          {
            path: "/console/knowledge/retrievalFile",
            name: "retrievalFile",

            component: () =>
              import("@/views/console/KnowledgeBase/RetrievalFile.vue"),
            meta: {
              showPath: "/console/knowledge",
              tabName: "/ 创造 / 知识库 / 检索测试",
              titleName: "知识库",
            },
          },
          {
            path: "/console/knowledge/baseSetting",
            name: "baseSetting",

            component: () =>
              import("@/views/console/KnowledgeBase/BaseSetting.vue"),
            meta: {
              showPath: "/console/knowledge",
              tabName: "/ 创造 / 知识库 / 知识库配置",
              titleName: "知识库",
            },
          },
          {
            path: "/console/knowledge/mediaResource",
            name: "mediaResource",
            component: () =>
              import("@/views/console/KnowledgeBase/MediaResource.vue"),
            meta: {
              showPath: "/console/knowledge",
              tabName: "/ 创造 / 知识库 / 素材管理",
              titleName: "知识库",
            },
          },
        ],
      },
      {
        path: "/console/database",
        name: "database",
        component: () => import("@/views/console/DataBase/index.vue"),
        meta: {
          showPath: "/console/database",
          tabName: "/ 创造 / 数据库",
          titleName: "数据库",
        },
      },
      {
        path: "/console/database/navigation",
        name: "databaseNavigation",
        component: () =>
          import("@/views/console/DataBase/databaseNavigation.vue"),
        redirect: "/console/database/databaseNavigation/preview",
        children: [
          {
            path: "/console/database/preview",
            name: "databasePreview",
            component: () =>
              import("@/views/console/DataBase/databasePreview.vue"),
            meta: {
              showPath: "/console/database",
              tabName: "/ 创造 / 数据库 / 数据预览",
              titleName: "数据库",
            },
          },
          {
            path: "/console/database/tableConfig",
            name: "tableConfig",
            component: () => import("@/views/console/DataBase/tableConfig.vue"),
            meta: {
              showPath: "/console/database",
              tabName: "/ 创造 / 数据库 / 数据表配置",
              titleName: "数据库",
            },
          },
          {
            path: "/console/database/databaseConfig",
            name: "databaseConfig",
            component: () =>
              import("@/views/console/DataBase/databaseConfig.vue"),
            meta: {
              showPath: "/console/database",
              tabName: "/ 创造 / 数据库 / 数据库配置",
              titleName: "数据库",
            },
          },
        ],
      },
      {
        path: "/console/model",
        name: "model",
        redirect: "/console/models",
        children: [
          {
            path: "/console/models",
            name: "modelManage",
            component: () => import("@/views/console/ModelManage/index.vue"),
            meta: {
              showPath: "/console/model",
              tabName: "/ 管理 / 模型服务",
              titleName: "模型服务",
            },
          },
          {
            // Deep link: open model detail drawer automatically
            path: "/console/models/:modelCode/detail",
            name: "modelManageDetail",
            component: () => import("@/views/console/ModelManage/index.vue"),
            meta: {
              showPath: "/console/model",
              tabName: "/ 管理 / 模型服务",
              titleName: "模型服务",
            },
          },
          {
            // Deep link: open API access drawer automatically
            path: "/console/models/:modelCode/api",
            name: "modelManageApi",
            component: () => import("@/views/console/ModelManage/index.vue"),
            meta: {
              showPath: "/console/model",
              tabName: "/ 管理 / 模型服务",
              titleName: "模型服务",
            },
          },
          {
            // Inline model playground (embedded under console layout). Lives
            // directly at /console/models/:modelCode (no /playground suffix)
            // so the "立即体验" link reads cleanly. Note this coexists with
            // the sibling /detail and /api routes — vue-router matches the
            // more-specific paths first.
            path: "/console/models/:modelCode",
            name: "modelPlayground",
            component: () =>
              import(
                /* webpackChunkName: "model-playground" */ "@/views/console/ModelManage/ModelPlayground.vue"
              ),
            meta: {
              showPath: "/console/model",
              tabName: "/ 管理 / 模型服务 / 立即体验",
              titleName: "模型体验",
            },
          },
        ],
      },
      {
        // "能力" menu entry: lands on the first tab, skills.
        path: "/console/ability",
        name: "ability",
        redirect: () => abilityEntryPath(),
      },
      {
        path: "/console/mcp",
        name: "mcpServers",
        component: () => import("@/views/console/Ability/index.vue"),
        meta: {
          showPath: "/console/ability",
          tabName: "/ 创造 / 能力 / MCP",
          titleName: "MCP",
        },
      },
      {
        path: "/console/plugins",
        name: "plugins",
        component: () => import("@/views/console/Ability/index.vue"),
        meta: {
          showPath: "/console/ability",
          tabName: "/ 创造 / 能力 / 插件",
          titleName: "插件",
        },
      },
      {
        path: "/console/templates",
        name: "templateCenter",
        component: () => import("@/views/console/TemplateCenter/index.vue"),
        meta: {
          showPath: "/console/templates",
          tabName: "/ 发现 / 模板中心",
          titleName: "模板中心",
        },
      },
      {
        path: "/console/skills",
        name: "skillMarket",
        component: () => import("@/views/console/Ability/index.vue"),
        meta: {
          showPath: "/console/ability",
          tabName: "/ 创造 / 能力 / 技能",
          titleName: "技能",
        },
      },
      {
        path: "/console/skills/detail/:slug",
        name: "skillDetail",
        component: () => import("@/views/console/SkillMarket/SkillDetail.vue"),
        meta: {
          showPath: "/console/ability",
          tabName: "/ 创造 / 能力 / 技能 / 详情",
          titleName: "技能详情",
        },
      },
      {
        path: "/console/skills/create",
        name: "skillCreate",
        component: () => import("@/views/console/SkillMarket/SkillCreate.vue"),
        beforeEnter: () => (rightJudgment("createSkill") ? true : { name: "skillMarket", replace: true }),
        meta: {
          showPath: "/console/ability",
          tabName: "/ 创造 / 能力 / 技能 / 创建",
          titleName: "创建技能",
        },
      },
      {
        // 内容创作：实际不渲染页面，导航守卫会拦截并跳转到 studioDomainName 外链
        path: "/console/contentCreation",
        name: "contentCreation",
        component: () => import("@/views/console/TemplateCenter/index.vue"),
        meta: {
          showPath: "/console/contentCreation",
          tabName: "/ 发现 / 内容创作",
          titleName: "内容创作",
          externalStudioDomain: true,
        },
      },
      {
        path: "/console/template/:code",
        name: "templateChat",
        component: () =>
          import("@/views/console/TemplateCenter/TemplateChat.vue"),
        meta: {
          showPath: "/console/templates",
          tabName: "/ 发现 / 模板中心 / 模板详情",
          titleName: "模板中心",
        },
      },
      {
        path: "/console/workflows",
        name: "flow",
        component: () => import("@/views/console/FlowWork.vue"),
        meta: {
          showPath: "/console/workflows",
          tabName: "/ 创造 / 工作流",
          titleName: "工作流",
        },
      },
      {
        path: "/console/plugins/detail",
        name: "customPlugin",
        component: () =>
          import("@/views/console/PLuginManage/CustomPlugin.vue"),
        // MCP has its own editor route; keep old links with pluginType=mcp working
        beforeEnter: (to: any) =>
          to.query.pluginType === "mcp"
            ? { name: "customMcp", query: to.query, replace: true }
            : true,
        meta: {
          showPath: "/console/ability",
          tabName: "/ 创造 / 能力 / 插件 / 自定义插件",
          titleName: "插件",
        },
      },
      {
        path: "/console/mcp/detail",
        name: "customMcp",
        component: () =>
          import("@/views/console/PLuginManage/CustomPlugin.vue"),
        meta: {
          showPath: "/console/ability",
          tabName: "/ 创造 / 能力 / MCP / 自定义MCP",
          titleName: "MCP",
        },
      },
      {
        path: "/console/plugins/formlist",
        name: "formlist",
        component: () => import("@/views/console/formSet/FormList.vue"),
        meta: {
          showPath: "/console/ability",
          tabName: "/ 创造 / 能力 / 插件 / 表单",
          titleName: "表单",
        },
      },
      {
        path: "/console/plugins/formset",
        name: "formset",
        component: () => import("@/views/console/formSet/index.vue"),
        meta: {
          showPath: "/console/ability",
          tabName: "/ 创造 / 能力 / 插件 / 表单",
          titleName: "表单",
        },
      },
      {
        path: "/console/teamSpace",
        name: "teamSpace",
        component: () => import("@/views/console/TeamSpace/index.vue"),
        meta: {
          showPath: "/console/teamSpace",
          tabName: "/ 管理 / 团队空间",
          titleName: "团队空间",
        },
      },
      {
        path: "/console/teamSpace/roleEdit",
        name: "roleEdit",
        component: () => import("@/views/console/TeamSpace/RightTree.vue"),
        meta: {
          showPath: "/console/teamSpace",
          tabName: "/ 管理 / 团队空间",
          titleName: "团队空间",
        },
      },
      {
        path: "/console/price",
        name: "price",
        component: () =>
          import(/* webpackChunkName: "about" */ "@/views/RechargeView.vue"),
        meta: {
          showPath: "/console/account",
          tabName: "/购买",
          titleName: "购买",
        },
      },
      {
        path: "/console/customManage",
        name: "customManage",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/console/CustomManage/index.vue"
          ),
        redirect: "/console/customManage/customerList",
        children: [
          {
            path: "/console/customManage/customerList",
            name: "customerList",
            component: () =>
              import("@/views/console/CustomManage/compoents/CustomerList.vue"),
            meta: {
              showPath: "/console/customManage",
              tabName: "/ 接入 / 客户管理 / 客户列表",
              titleName: "客户管理",
            },
          },
          {
            path: "/console/customManage/tagList",
            name: "tagList",
            component: () =>
              import("@/views/console/CustomManage/compoents/TagList.vue"),
            meta: {
              showPath: "/console/customManage",
              tabName: "/ 接入 / 客户管理 / 标签管理",
              titleName: "客户管理",
            },
          },
        ],
      },
    ],
  },
  {
    path: "/pluginKey",
    name: "pluginKey",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/pluginKey.vue"),
  },
  {
    path: "/console/workflow",
    name: "addFlow",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/vueFlow/VueFlow.vue"),
  },
  {
    // Backwards-compat: old `/playground` suffix redirects to the new short
    // path. Keep this around so any externally bookmarked / shared URLs from
    // before the rename keep working.
    path: "/console/models/:modelCode/playground",
    redirect: (to) => ({
      name: "modelPlayground",
      params: { modelCode: to.params.modelCode as string },
    }),
  },
  {
    path: "/benefits",
    name: "inviteActivi",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/InviteActivi.vue"),
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "@/views/ChatView.vue"),
  // },
  {
    // 纯对话内嵌页：仅渲染 PreviewPanel，供内容创作平台等以 iframe 嵌入。
    // 通过 ?token= 传入内容平台 token 实现单点登录（SSO）。
    path: "/web/superagent/:code",
    name: "superAgentChat",
    component: () => import("@/views/console/superAgent/SuperagentChat.vue"),
  },
  {
    path: "/web/linkAI/:clientId",
    name: "web",
    component: () => import("@/views/console/ibotManage/iframeChat.vue"),
  },
  {
    path: "/web/iframe/:clientId",
    name: "fullweb",
    component: () => import("@/views/console/ibotManage/iframeFullChat.vue"),
  },
  {
    path: "/web/form/:clientId",
    name: "formfill",
    component: () => import("@/views/console/formSet/FormFill.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/loginWeb/index.vue"),
  },
  {
    // CLI device-flow authorization landing page (opened from `linkai auth login`)
    path: "/cli-login",
    name: "cliLogin",
    component: () => import("@/views/cliLogin/index.vue"),
  },
  {
    path: "/401",
    name: "401",
    component: () => import("@/views/NoPrivige.vue"),
  },
  {
    path: "/:pathMatch(.*)",
    //访问主页的时候 重定向到index页面
    redirect: "/404",
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/Not404.vue"),
  },
  {
    path: "/iframe",
    name: "iframes",
    component: () => import("@/views/console/ibotManage/iframeTest.vue"),
  },
  {
    path: "/cowagent/create",
    name: "createSuperAgent",
    component: () => import("@/views/console/superAgent/index.vue"),
  },
];
//router/index.js

const router = createRouter({
  scrollBehavior() {
    // 始终滚动到顶部
    return { top: 0 };
  },
  history: createWebHistory(),
  routes,
});

function findMenuByPath(menuList: any, path: any): any {
  for (const item of menuList) {
    // 检查当前项的路径
    if (item.path === path) {
      return item; // 找到匹配项
    }
    // 如果有子菜单，递归查找
    if (item.children) {
      const found = findMenuByPath(item.children, path);
      if (found) {
        return item; // 返回父菜单
      }
    }
  }
  return null; // 如果没有找到，返回 null
}
/** Append `skill` so the content studio homepage can stage that skill. Invalid bases stay unchanged. */
function withSkillQuery(raw: string, skill: string): string {
  if (!skill) return raw;
  try {
    const url = new URL(/^[a-z]+:\/\//i.test(raw) ? raw : `https://${raw}`);
    url.searchParams.set("skill", skill);
    return url.toString();
  } catch {
    return raw;
  }
}

router.beforeEach((to: any, from, next) => {
  // 「创作」/「内容创作」为外链菜单：在新标签页打开用户信息中的
  // companyStudioDomainName 链接，并取消本次路由切换（不渲染对应页面）
  if (to.meta && to.meta.externalStudioDomain) {
    try {
      // "去使用" on a content skill passes its skill_key; the studio homepage stages it.
      const skill = typeof to.query?.skill === "string" ? to.query.skill.trim() : "";
      const open = (raw: string) => window.open(withSkillQuery(raw, skill), "_blank");
      if (judgementShwo()) {
        // Non-OEM (official LinkAI domain): open the fixed studio link by env.
        const domain = getCurrentFullDomain();
        const isProd =
          domain === "https://link-ai.tech" ||
          domain === "http://link-ai.tech";
        open(isProd ? "https://studio.link-ai.tech" : "http://studio.link-ai.cloud");
      } else {
        // OEM: open the companyStudioDomainName configured in user info.
        const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
        const companyStudioDomainName =
          userInfo && userInfo.companyStudioDomainName;
        if (companyStudioDomainName) {
          open(
            /^https?:\/\//i.test(companyStudioDomainName)
              ? companyStudioDomainName
              : `https://${companyStudioDomainName}`,
          );
        }
      }
    } catch (error) {
      console.error("打开内容创作平台链接失败:", error);
    }
    next(false);
    return;
  }

  // Allow access to login page without authentication
  if (to.path === "/login") {
    next();
    return;
  }

  // CLI authorization page handles its own auth check (redirects to /login
  // when no token), so let it through here regardless of domain/login state.
  if (to.path === "/cli-login") {
    next();
    return;
  }

  const a = getCurrentFullDomain();
  if (
    a !=="https://link-ai.tech" &&
    a !=="http://link-ai.tech" &&
    !a.includes("test.link-ai.cloud") &&
    !a.includes("localhost") &&
    !localStorage.getItem("token") &&
    !to.path.includes("/web/linkAI") &&
    !to.path.includes("/web/iframe") &&
    !to.path.includes("/web/superagent") &&
    !to.path.includes("/web/form") &&
    !to.path.includes("/404")
  ) {
    next({ path: "/login" });
    return;
  }
  const store = createStore();
  const userDetail = store.state.user;
  store.action.saveToRouter(to.name, from.name);
  if (userDetail.authorizedRoute) {
    // Routes with params are listed by their pattern, e.g. /console/skills/detail/:slug
    const pattern = to.matched.length ? to.matched[to.matched.length - 1].path : to.path;
    const allow = findMenuByPath(authMenu, to.path) || findMenuByPath(authMenu, pattern);

    try {
      if (allow.isAuthen && allow.isAuthen === "Y") {
        const go = userDetail.authorizedRouteList.includes(allow.path);
        if (go) {
          next();
        } else {
          // ElMessage({
          //   type: 'warning',
          //   message: '暂无权限'
          // })
          if (userDetail.authorizedRouteList.length > 0) {
            next({ path: userDetail.authorizedRouteList[0] });
          } else {
            next({ path: "/401" });
          }
          return;
        }
      } else {
        next();
      }
    } catch {
      next();
    }

    // console.log(7, userDetail.authorizedRouteList)
    // const a = getRouterName(userDetail.authorizedRouteList)
  } else {
    // if (to.name === 'clients' && store.state.userPrivige.clientManage < 1) {
    //   ElMessage({
    //     type: 'warning',
    //     message: '暂无权限'
    //   })
    //   return
    // }
    // if (to.name === 'chatManage' && store.state.userPrivige.customerManage < 1) {
    //   ElMessage({
    //     type: 'warning',
    //     message: '暂无权限'
    //   })
    //   return
    // }
    // if (to.name === 'teamSpace' && store.state.userPrivige.memberNumber < 1) {
    //   ElMessage({
    //     type: 'warning',
    //     message: '暂无权限'
    //   })
    //   return
    // }
    next();
  }
});
export default router;
